// Texts of Settings → Devices (PR B1). Pure; tested in test/password.test.ts.

import { shortDate as zoneShortDate } from './time';

const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

/** "Active now", "12 minutes ago", "3 hours ago", "Yesterday", "Oct 3". Sessions note their use every ~5 min. */
export function lastUsedText(iso: string | null, nowMs: number): string {
  const t = iso ? Date.parse(iso) : NaN;
  if (!Number.isFinite(t)) return 'Not used recently';
  const ago = nowMs - t;
  if (ago < 10 * MIN) return 'Active now';
  if (ago < HOUR) return `${Math.floor(ago / MIN)} minutes ago`;
  if (ago < 2 * HOUR) return '1 hour ago';
  if (ago < DAY) return `${Math.floor(ago / HOUR)} hours ago`;
  if (ago < 2 * DAY) return 'Yesterday';
  return shortDate(t, nowMs);
}

/** "Oct 3" this year, "Oct 3, 2025" otherwise. */
export function shortDate(t: number, nowMs: number): string {
  return zoneShortDate(t, nowMs);
}

/** The folded Devices row: "Signed in on 3 devices · this one: Firefox on Windows". */
export function devicesSummary(list: { device: string; current: boolean }[] | null, failed: boolean): string {
  if (!list) return failed ? 'Couldn’t load your devices.' : 'Loading…';
  const me = list.find((d) => d.current);
  if (list.length <= 1) return me ? `Only this device: ${me.device}` : 'No devices signed in.';
  return `Signed in on ${list.length} devices${me ? ` · this one: ${me.device}` : ''}`;
}
